import { useQuery } from '@tanstack/react-query';
import { getReferralDataById } from '../rake.service';
import { UseQueryResult } from '@tanstack/react-query/build/modern';
import { ReferralStats } from '@/services/rake/rake.types';

interface useGetReferralStatsByIdResult {
  data: ReferralStats;
}
const useGetReferralStatsById = ({
  referralId,
}: {
  referralId: string;
}): UseQueryResult<useGetReferralStatsByIdResult, Error> => {
  return useQuery<useGetReferralStatsByIdResult, Error>({
    queryKey: ['referral-data-by-id'],
    queryFn: () => getReferralDataById(referralId),
  });
};

export default useGetReferralStatsById;
